<div class="website-wrapper">
  <app-header />
  <div class="main-page-wrapper">
    <div class="site-content" role="main">
      <router-outlet />
    </div>
  </div>
  <app-footer />
</div>

<div class="basel-close-side" (click)="closeSide()"></div>
<app-bag-drawer />
<a href="#" class="scrollToTop basel-tooltip" [class.scrollToTop-show]="showTop" (click)="scrollTop($event)"
  >Scroll To Top</a
>
@if (showVisitorChat()) {
  <app-visitor-chat-widget />
}
